import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { ButtonIntents } from 'shared/ui/Button'
import Flex from 'shared/ui/Flex'
import ModalButton from 'shared/ui/ModalButton'
import IslandModal, {
  IslandModalProps
} from 'shared/components/modals/IslandModal'

const Description = styled.p`
  color: ${({ theme }) => theme.color.base.c5};
  text-align: center;
`

type ConfirmDeleteModalProps = Pick<
  IslandModalProps,
  'isOpen' | 'closeModal'
> & {
  onConfirm: () => Promise<void> | void
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  closeModal,
  onConfirm
}) => {
  const { formatMessage } = useIntl()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      setIsLoading(false)
    }
  }, [isOpen])

  const handleConfirm = async () => {
    setIsLoading(true)
    try {
      await onConfirm()
      closeModal()
    } catch (error) {
      setIsLoading(false)
    }
  }

  const handleCancel = () => {
    if (!isLoading) {
      closeModal()
    }
  }

  const handleCloseModal = () => {
    if (!isLoading) {
      closeModal()
    }
  }

  return (
    <IslandModal
      isOpen={isOpen}
      closeModal={handleCloseModal}
      width={345}
      title={formatMessage({
        id: `Project.settings.danger.modal.title`
      })}
    >
      <Description>
        {formatMessage({
          id: 'Project.settings.danger.modal.description'
        })}
      </Description>

      <Flex marginTop={48} columnGap={7}>
        <ModalButton
          labelId="Actions.cancel"
          isFullWidth
          intent={ButtonIntents.neutral}
          onClick={handleCancel}
          isDisabled={isLoading}
        />
        <ModalButton
          labelId="Project.settings.danger.modal.confirm"
          intent={ButtonIntents.danger}
          isFullWidth
          onClick={handleConfirm}
          loading={isLoading}
          isDisabled={isLoading}
        />
      </Flex>
    </IslandModal>
  )
}

export default ConfirmDeleteModal
